import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ThreadSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ThreadSVG;
